import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { BlankType } from "../../types";
import BlankPollValue from "./BlankPollValue.vue";
import BlankScaleValue from "./BlankScaleValue.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BlankValue',
    props: {
        response: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (__props.response.blankType == undefined || __props.response.blankType == _unref(BlankType).CHOICE)
                ? (_openBlock(), _createBlock(BlankPollValue, {
                    key: 0,
                    response: __props.response
                }, null, 8, ["response"]))
                : (__props.response.blankType == _unref(BlankType).SCALE)
                    ? (_openBlock(), _createBlock(BlankScaleValue, {
                        key: 1,
                        response: __props.response
                    }, null, 8, ["response"]))
                    : _createCommentVNode("", true);
        };
    }
});
